import React from 'react';
import { Copy, SystemText } from '@salesperformanceint/e4shared';
import Rating from '../rating';
import { useSelector } from 'react-redux';
import { translatePI } from 'helpers/translations';

export const PositiveIndicatorTable = ({ data }) => {
    const [hasUserRating, setHasUserRating] = React.useState(false);
    const [hasManagerRating, setHasManagerRating] = React.useState(false);

    const { user } = useSelector(state => state.user);

    const text = {
        positive: SystemText('BehaviourDetails/Table/Positive'), //Positive indicator
        your: SystemText('BehaviourDetails/Table/Your'), //Your Rating
        manager: SystemText('BehaviourDetails/Table/Manager'), //Manager Rating
    };

    React.useEffect(() => {
        setHasUserRating(data.some(pi => pi.userRated));
        setHasManagerRating(data.some(pi => pi.managerRated));
    }, [data]);

    return (
        <>
            <table className="prism-data-table mb20">
                <thead>
                    <tr>
                        <th>{text.positive}</th>
                        {hasUserRating && (
                            <th className="text-center" style={{ minWidth: '95px' }}>
                                <Copy value={text.your.replace('\n', '<br />')} />
                            </th>
                        )}
                        {hasManagerRating && (
                            <th className="text-center" style={{ minWidth: '95px' }}>
                                <Copy value={text.manager.replace('\n', '<br />')} />
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {data.map(pi => {
                        pi = translatePI(user.language_Code, pi);
                        return (
                            <tr key={`pi-${pi.id}`}>
                                <td>{pi.statement}</td>
                                {hasUserRating && (
                                    <td className="text-center">
                                        <Rating level={pi.userRated} hideOutOf />
                                    </td>
                                )}
                                {hasManagerRating && (
                                    <td className="text-center">
                                        <Rating level={pi.managerRated} hideOutOf />
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

export default PositiveIndicatorTable;
